module.exports = __webpack_public_path__ + "img/print.2ba15dde.svg";